import React, { useEffect, useRef, useState } from "react";
import "./quienes-somos.css";
// Rutas de importación actualizadas
import { getTarjetasInicio } from "../../config/services/strapi/home";
import { getQuienesSomosDetalle } from "../../config/services/strapi/quienes-somos";
import TextSkeleton from "../../components/Skeleton/TextSkeleton";
import ImageSkeleton from "../../components/Skeleton/ImageSkeleton";

export default function QuienesSomos() {
  const videoRef = useRef<HTMLVideoElement>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const [heroData, setHeroData] = useState<any>(null);
  const [detalleData, setDetalleData] = useState<any>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadAllData() {
      try {
        const [tarjetas, detalle] = await Promise.all([
          getTarjetasInicio(),
          getQuienesSomosDetalle(),
        ]);

        const tarjetaHero = tarjetas.find(
          (t: any) => t.titulo === "QUIÉNES SOMOS"
        );

        setHeroData(tarjetaHero);
        setDetalleData(detalle);
      } catch (error) {
        console.error("Error cargando datos de Strapi:", error);
      } finally {
        setLoading(false);
      }
    }
    loadAllData();
  }, []);

  useEffect(() => {
    if (loading || !heroData) return;
    const video = videoRef.current;
    if (!video) return;

    const handleResize = () => {
      if (window.innerWidth < 769) {
        video.pause();
      } else {
        video.play();
      }
    };

    const onPlay = () => setIsPlaying(true);
    const onPause = () => setIsPlaying(false);

    video.addEventListener('play', onPlay);
    video.addEventListener('pause', onPause);
    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      video.removeEventListener('play', onPlay);
      video.removeEventListener('pause', onPause);
      window.removeEventListener("resize", handleResize);
    };
  }, [loading, heroData]);

  const togglePlay = () => {
    if (videoRef.current) {
      videoRef.current.paused ? videoRef.current.play() : videoRef.current.pause();
    }
  };

  const heroVideoUrl = detalleData?.heroVideoUrl?.url || null;
  const detalleVideoUrl = detalleData?.videoUrl?.url || null;

  // Helper: render hero title (reduce inline complexity)
  const renderHeroTitle = () => {
    if (loading) return <TextSkeleton />;

    const words: string[] = heroData?.Titulo?.split(" ") || ["QUIÉNES", "SOMOS"];
    return (
      <h1>
        {words.map((word: string, i: number) => (
          <React.Fragment key={i}>
            {word} {i === 0 && <br />}
          </React.Fragment>
        ))}
      </h1>
    );
  };

  // Helper: render hero media (video or placeholder)
  const renderHeroMedia = () => {
    if (loading) return <ImageSkeleton className="h-full" />;
    if (heroVideoUrl) {
      return (
        <video
          ref={videoRef}
          src={heroVideoUrl}
          className="media-cover-quienes-somos"
          preload="metadata"
          playsInline
          muted
          loop
        />
      );
    }
    return null;
  };

  // Helper: render detalle text blocks
  const renderDetalleText = () => {
    if (loading) return <TextSkeleton />;

    return detalleData?.descripcion?.map((block: any, index: number) => {
      const textContent = block.children?.map((c: any) => c.text).join("");
      if (!textContent) return null;

      if (index === detalleData.descripcion.length - 1) {
        return <h4 key={index}>{textContent}</h4>;
      }
      return <p key={index}>{textContent}</p>;
    });
  };

  // Extracted nested ternary into a single variable to simplify JSX
  let detalleMediaContent: JSX.Element | null = null;
  if (loading) {
    detalleMediaContent = <ImageSkeleton className="h-full" />;
  } else if (detalleVideoUrl) {
    detalleMediaContent = (
      <iframe
        src={detalleVideoUrl}
        title="Video Detalle"
        allow="autoplay; fullscreen"
        loading="lazy"
        style={{ border: 'none', width: '100%', height: '100%', minHeight: '350px' }}
      />
    );
  } else {
    detalleMediaContent = <div className="loading-placeholder">Cargando video de detalle...</div>;
  }

  return (
    <>
      <section className="section-quienes-somos">
        <div className="section-inner-quienes-somos">
          <div className="col-text-quienes-somos quienes-somos">
            {renderHeroTitle()}
          </div>

          <div className="col-media-quienes-somos">
            <div className="video-container-wrapper" style={{ position: 'relative', width: '100%', height: '100%' }}>
              {renderHeroMedia()}

              {!isPlaying && heroVideoUrl && (
                <div className="absolute-center-play" onClick={togglePlay} style={{ cursor: 'pointer', zIndex: 10 }}>
                  <svg viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                    <circle className="circle-outline" cx="50" cy="50" r="45" />
                    <path className="play-shape" d="M40,30l30,20L40,70V30z" />
                  </svg>
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      <section className="section-detalle-quienes-somos quienes-somos-detalle">
        <div className="section-inner-detalle-quienes-somos detalle-inner-quienes-somos">

          <div className="detalle-text-quienes-somos">{renderDetalleText()}</div>

          <div className="detalle-video-quienes-somos">{detalleMediaContent}</div>
        </div>
      </section>
    </>
  );
}